import { useLocation } from "react-router-dom";
import TableLayout from "../../components/TableLayout";
import { useFetchData } from "../../hooks/useFetchData";
import { API_URL } from "../../utils/constant";
import React, {useState} from "react";

const headers = [
  {
    key: "customer_name",
    name: "Customer Name",
  },
  {
    key: "member_code",
    name: "Member Card Number",
  },
  {
    key: "loyalty_points",
    name: "Point",
  },

  {
    key: "advanced_mmk",
    name: "Advanced MMK",
  },

  {
    key: "advanced_thb",
    name: "Advanced THB",
  },
  {
    key: "phone1",
    name: "Phone",
  },
  {
    key: "address",
    name: "Address",
  },
  {
    key: "status",
    name: "Status",
  },
];

const detailPopupHeaders = [
  {
    key: "retail_customer_code",
    name: "Retail Customer ID",
  },
  {
    key: "customer_name",
    name: "Customer Name",
  },
  {
    key: "member_code",
    name: "Member Card Number",
  },
  {
    key: "phone1",
    name: "Phone 1",
  },
  {
    key: "phone2",
    name: "Phone 2",
  },
  {
    key: "phone3",
    name: "Phone 3",
  },
  {
    key: "phone4",
    name: "Phone 4",
  },
  {
    key: "address",
    name: "Address",
  },
];

export default function RetailCustomerList() {
  const location = useLocation();
  const currentPath = location.pathname;
  const [searchValue, setSearchValue] = useState("");


  // const handleSearch = (value) => {
  //   setQuery({
  //     customer_name: value.trim(),
  //   });
  // };

  //  const handleSearch = (value) => {
  //   const trimmed = value.trim();
  //   setSearchValue(trimmed);
  //   setQuery({
  //     name: trimmed,
  //   });
  // };

   const handleSearch = (value) => {
    const trimmed = value.trim();
    if(trimmed.length > 0){
      setSearchValue(trimmed);
      setQuery({
        search: trimmed,
      });
    }else{
        setQuery({
      
    });
    }
  };

  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: API_URL + "/retailCustomer",
    defaultQuery: "status=ACTIVE",
  });

  const nothingFoundAfterSearch =
    searchValue && Array.isArray(data?.results) && data.results.length === 0;

  return (
    <TableLayout
      title="Retail Customer List"
      data={data}
      headers={headers}
      detailPopupTitle="Retail Customer Information"
      detailPopupHeaders={detailPopupHeaders}
      idKey="customer_id"
      endPoint="/retailCustomer"
      setCurrentPage={setCurrentPage}
      hasSearch
      hasCreate
      hasPointChange
      pointChangeModel="RetailCustomer"
      module="Customer"
      subModule="Retail Customer"
      createPath={`/customer/retail/create`}
      hasActions
      totalCount={data.totalCount}
      currentPath={currentPath}
      onSearch={(value) => handleSearch(value)}
      reload={reload}
      searchValue={searchValue}
      nothingFoundAfterSearch={nothingFoundAfterSearch}
      setQuery={setQuery}
    />
  );
}
